import { useQuery } from '@tanstack/react-query';
import { api, cdApi } from '../lib/api';
import techniqueChecker from '../utils/techniqueChecker';

function useSessionSurveyResults({
  token,
  page,
  page_size,
  start_date,
  end_date,
  order,
  order_by,
  technique,
  status,
}) {
  const fetchSimpleAggregates = async () => {
    const params = {
      order_by: 'score',
      score: true,
      page: 1,
      page_size: 1000,
      start_date: start_date ?? '',
      end_date: end_date ?? '',
    };

    try {
      const { data } = await api.get('/masseuses/', {
        params,
      });

      const { data: masseuses } = await cdApi.get('/masseuses/', {
        params: { page: 1, page_size: 1000 },
      });

      let modifiedMasseuses = [];

      data.results.forEach((masseuse) => {
        let masseuseDetails = masseuses.results.find(
          (m) => m.id === masseuse.id,
        );

        let masseuseTemp = {};
        masseuseTemp = { ...masseuse, ...masseuseDetails };

        modifiedMasseuses.push(masseuseTemp);
      });

      let filteredMasseuses = [];

      if (status === true) {
        filteredMasseuses = modifiedMasseuses.filter(
          (masseuse) => masseuse.profile_visible === true,
        );
      } else if (status === false) {
        filteredMasseuses = modifiedMasseuses.filter(
          (masseuse) => masseuse.profile_visible === false,
        );
      } else if (status === null) {
        filteredMasseuses = [...modifiedMasseuses];
      }

      if (techniqueChecker(technique)) {
        let sensualMasseuses = filteredMasseuses.filter((masseuse) =>
          techniqueChecker(masseuse.technique),
        );

        return sensualMasseuses;
      } else if (technique === 'Shiatsu') {
        let shiatsuMasseuses = filteredMasseuses.filter(
          (masseuse) => masseuse.technique === 'Shiatsu',
        );
        return shiatsuMasseuses;
      } else {
        return filteredMasseuses;
      }
    } catch (error) {
      throw new Error('Failed to fetch Session Survey Results');
    }
  };

  const queryKey = [
    'sessionSurveyResults',
    start_date,
    end_date,
    technique,
    status,
  ];

  const { data, error, isLoading } = useQuery({
    queryKey,
    queryFn: fetchSimpleAggregates,
    gcTime: Infinity,
    staleTime: Infinity,
  });

  return {
    rows: data,
    isLoading,
    error,
  };
}

export default useSessionSurveyResults;
